

// import React from 'react';
// import { Box, List, ListItemButton, Tooltip } from '@mui/material';
// import { useNavigate, useLocation } from 'react-router-dom';
// import DashboardIcon from '@mui/icons-material/Dashboard';
// import ContactsIcon from '@mui/icons-material/Contacts';
// import AssignmentIcon from '@mui/icons-material/Assignment';
// import LogoutIcon from '@mui/icons-material/Logout'; // Logout icon import kara

// // लोगो इम्पोर्ट करा
// import CRMLogo from '../assets/crmimg.png';

// const Sidebar = () => {
//   const navigate = useNavigate();
//   const location = useLocation();

//   const menuItems = [
//     { id: 'Dashboard', icon: <DashboardIcon />, path: '/dashboard' },
//     { id: 'Inquiry Form', icon: <AssignmentIcon />, path: '/dashboard/inquiry' },
//     { id: 'Leads', icon: <ContactsIcon />, path: '/dashboard/leads' },
//   ];

//   const handleLogout = () => {
//     // Session clear logic ithe lihu shakto
//     navigate('/');
//   };

//   return (
//     <Box sx={{
//       width: 70,
//       bgcolor: '#ffffff',
//       height: '100%',
//       display: 'flex',
//       flexDirection: 'column',
//       alignItems: 'center',
//       justifyContent: 'space-between',
//       py: 2,
//       zIndex: 1300, // Topbar peksha pan jasta z-index dila ahe
//       position: 'relative', // Shadow render honyasathi relative position garjechi ahe
//       // High-End Premium Shadow
//       boxShadow: '10px 0px 20px rgba(0, 0, 0, 0.08)',
//       borderRight: 'none', // Shadow asel tar border chi garaj nahi, design clean diste
//       boxSizing: 'border-box'
//     }}>

//       {/* Top Section: Logo + Menu Items */}
//       <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
//         {/* लोगो */}
//         <Box sx={{ mb: 4, cursor: 'pointer' }} onClick={() => navigate('/dashboard')}>
//           <img src={CRMLogo} alt="CRM Logo" style={{ width: 60, height: 'auto' }} />
//         </Box>

//         <List>
//           {menuItems.map((item) => {
//             const isActive = location.pathname === item.path;
//             return (
//               <Tooltip title={item.id} placement="right" key={item.id}>
//                 <ListItemButton
//                   onClick={() => navigate(item.path)}
//                   sx={{
//                     mb: 2, borderRadius: '50%', width: 50, height: 50,
//                     justifyContent: 'center',
//                     border: isActive ? '2px solid #1a237e' : 'none',
//                     color: isActive ? '#1976d2' : '#757575',
//                     bgcolor: isActive ? '#e3f2fd' : 'transparent',
//                     '&:hover': { bgcolor: '#f5f5f5' }
//                   }}>
//                   {item.icon}
//                 </ListItemButton>
//               </Tooltip>
//             );
//           })}
//         </List>
//       </Box>

//       {/* Bottom Section: Logout Button */}
//       <Box sx={{ mb: 2 }}>
//         <Tooltip title="Logout" placement="right">
//           <ListItemButton
//             onClick={handleLogout}
//             sx={{
//               borderRadius: '50%', width: 50, height: 50,
//               justifyContent: 'center',
//               color: '#d32f2f', // Red color for logout
//               bgcolor: '#fff5f5',
//               '&:hover': { bgcolor: '#ffebee' }
//             }}>
//             <LogoutIcon />
//           </ListItemButton>
//         </Tooltip>
//       </Box>

//     </Box>
//   );
// };

// export default Sidebar;
import React from 'react';
import { Box, List, ListItemButton, Tooltip } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';

// Modern & Premium Icons
import GridViewOutlinedIcon from '@mui/icons-material/GridViewOutlined';
import PostAddOutlinedIcon from '@mui/icons-material/PostAddOutlined';
import ReceiptLongOutlinedIcon from '@mui/icons-material/ReceiptLongOutlined';
import GroupsOutlinedIcon from '@mui/icons-material/GroupsOutlined';
import PowerSettingsNewOutlinedIcon from '@mui/icons-material/PowerSettingsNewOutlined';

import CRMLogo from '../assets/crmimg.png';

const Sidebar = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems = [
    { id: 'Dashboard', icon: <GridViewOutlinedIcon />, path: '/dashboard' },
    { id: 'Inquiry Form', icon: <PostAddOutlinedIcon />, path: '/dashboard/inquiry' },
    { id: 'Inquiry Details', icon: <ReceiptLongOutlinedIcon />, path: '/dashboard/inquiry-details' },
    { id: 'Leads', icon: <GroupsOutlinedIcon />, path: '/dashboard/leads' },
  ];

  const handleLogout = () => {
    // इथून डायरेक्ट लॉगिन पेजवर नेव्हिगेट होईल
    navigate('/');
  };

  return (
    <Box sx={{
      width: '100%', // MainLayout चा Box याची रुंदी ठरवेल
      bgcolor: '#ffffff',
      height: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'space-between',
      py: 3,
      boxShadow: '4px 0px 15px rgba(0, 0, 0, 0.05)',
    }}>

      <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', width: '100%' }}>
        {/* Logo Section */}
        <Box 
          sx={{ 
            mb: 5, 
            cursor: 'pointer', 
            transition: '0.3s', 
            '&:hover': { transform: 'rotate(-5deg) scale(1.1)' } 
          }} 
          onClick={() => navigate('/dashboard')}
        >
          <img src={CRMLogo} alt="CRM Logo" style={{ width: 45, height: 'auto' }} />
        </Box>

        {/* Menu Items */}
        <List sx={{ width: '100%', px: 1 }}>
          {menuItems.map((item) => {
            const isActive = location.pathname === item.path;
            return (
              <Tooltip title={item.id} placement="right" key={item.id} arrow>
                <ListItemButton
                  onClick={() => navigate(item.path)}
                  sx={{
                    mb: 2, 
                    mx: 'auto',
                    borderRadius: '12px',
                    width: 50, 
                    height: 50,
                    justifyContent: 'center',
                    color: isActive ? '#e65100' : '#64748B',
                    bgcolor: isActive ? 'rgba(230, 81, 0, 0.08)' : 'transparent',
                    transition: 'all 0.3s ease',
                    '&:hover': { 
                        bgcolor: 'rgba(230, 81, 0, 0.04)',
                        color: '#e65100',
                    },
                    // Active Indicator Line
                    '&::before': isActive ? {
                      content: '""',
                      position: 'absolute',
                      left: -8,
                      height: '24px',
                      width: '4px',
                      bgcolor: '#e65100',
                      borderRadius: '0 4px 4px 0'
                    } : {}
                  }}
                >
                  {React.cloneElement(item.icon, { sx: { fontSize: 24 } })}
                </ListItemButton>
              </Tooltip>
            );
          })}
        </List>
      </Box>

      {/* Bottom Logout Section */}
      
    </Box>
  );
};

export default Sidebar;